jQuery(document).ready(function($) {
  if ($("body").hasClass("page-template-page-press-releases")) {
    //Global script variables
    var date = new Date();
    var currentYear = date.getFullYear();
    var page_nonce = $(
      '.pressReleasesTabsContainer input[name="_wpnonce"]'
    ).val();
    var localized_ajax = localized.ajax_url;
    window.addEventListener("beforeunload", localStorage.removeItem('activeTab'));
    $("#ajax-archive .loading-overlay").show();
    $(".warning").hide();
    $(".pressReleaseCollapseBtnContainer").hide();
    $("#responseMessage").hide();

    //Prevents return key form submission for search
    $("#pr_search").on("keypress", function(e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode === 13) {
        $("button#searchsubmit").trigger("click");
        e.preventDefault();
        return false;
      }
      
    });


    //Clones pagination to the bottom
    var clonePageination = function(currentYear) {
      for (i = currentYear; i >= currentYear - 4; i--) {
        $("#tab-filtered" + i)
          .find(".filteredPaginate" + "." + i)
          .clone()
          .appendTo("#tab-filtered" + i + " " + "#bottomPagination");
      }
    };

    //Message for paged content when year has posts but is paged to far ahead
    var resultMessage = function(currentYear) {
      for (i = currentYear; i >= currentYear - 4; i--) {
        var results = $(
          "#tab-filtered" +
            i +
            " " +
            ".filterResultInfoContainer .resultsBox .results"
        ).html();
        var secondNumber = $(
          "#tab-filtered" +
            i +
            " " +
            ".filterResultInfoContainer .resultsBox .secondNumber"
        ).html();
        if (results > secondNumber) {
          $("#tab-filtered" + i + " " + "#responseMessage .goBack").show();
          $("#tab-filtered" + i + " " + "#responseMessage .noResults").hide();
          $("#tab-filtered" + i + " " + "#bottomPagination").hide();
        } else {
          $("#bottomPagination").show();
        }
      }
    };

    //Sets active tab after Ajax call
    var setActiveTab = function() {
      $("#pressReleasesTabsfilterContent li a").on('click', function() {
        var tab = $(this);
        tab.tab('show');
        localStorage.setItem("activeTab", tab[0].id);
        ajaxInitialPostBuild(page_nonce);
      });

      var activeTab = localStorage.getItem("activeTab");
      if (activeTab) {
        $('#pressReleasesTabsfilterContent #' + activeTab).tab("show");
      } else {
        //Set initial active tab
        $("#pressReleasesTabsfilterContent li:first-child a").tab("show");
      }

    };

    //Create select dropdown for mobile view
    var createSelect = function() {
      var $select = $(
        '<select class="custom-select" id="pressReleaseSelect"></select>'
      );
      var count = 0;
      $("#pressReleasesTabsfilterContent.nav-tabs li a").each(function() {
        $select.append(
          '<option value="' +
            count++ +
            '">' +
            "Viewing " +
            $(this).text() +
            " press releases (change)" +
            "</option>"
        );
      });

      $(".pressReleasesTabsContainer").before($select);

      $("#pressReleaseSelect").on("change", function(e) {
        $(".nav.nav-tabs li a")
          .eq($(this).val())
          .tab("show");
      });
    };

    //Call function

    var hideSelect = function() {
      $("#pressReleaseSelect").hide();
      $("#pressReleasesTabs").show();
    };

    var showSelect = function() {
      $("#pressReleaseSelect").show();
      $("#pressReleasesTabs").hide();
    };

    var widthCheck = function() {
      if ($(window).width() < 767) {
        showSelect();
      } else {
        hideSelect();
      }
    };

    widthCheck();

    $(window).resize(function() {
      widthCheck();
    });

    //Removes current result block and hides non-filtered content
    var successAjaxProc = function() {
      $(".dataContent").remove();
      $(".pressReleasesTabs.filterContent").show();
    };

    //Removed disabled class from pagination pieces
    var removeDisabled = function() {
      $(".filteredPaginate a").each(function() {
        $(this).removeClass("disabled");
      });
    };

    //Selects the View All filter box on load
    $('#checkAllContainer input[type="checkbox"]').attr("checked");
    $("#checkAllContainer .jh-checkbox").addClass("jh-checkbox--checked");

    //Filter Checkbox function
    $('#checkBoxesContainer input[type="checkbox"]').change(function() {
      $("#ajax-archive .loading-overlay").show();
      $('#checkAllContainer input[type="checkbox"]').removeAttr("checked");
      $("#checkAllContainer .jh-checkbox").removeClass("jh-checkbox--checked");
      var filter_nonce = $('#filter input[name="_wpnonce"]').val();
      var searchIDs = $("#checkBoxesContainer input:checkbox:checked")
        .map(function() {
          return $(this).attr("name");
        })
        .get();
      if ($(searchIDs).length === 0) {
        $("#ajax-archive .loading-overlay").show();
        $(".dataContent").remove();
        ajaxPostBuild();
        $('#checkAllContainer input[type="checkbox"]').attr("checked");
        $("#checkAllContainer .jh-checkbox").addClass("jh-checkbox--checked");
        $("#ajax-archive .loading-overlay").hide();
      } else {
        ajaxPostBuild(searchIDs, null, null, filter_nonce);
      }
      return searchIDs;
    });

    //Remove all checkbox filters
    $('#checkAllContainer input[type="checkbox"]').change(function() {
      $("#ajax-archive .loading-overlay").show();
      $('#checkBoxesContainer input[type="checkbox"]').each(function() {
        $('#checkBoxesContainer input[type="checkbox"]').removeAttr("checked");
        $("#checkBoxesContainer .jh-checkbox").removeClass(
          "jh-checkbox--checked"
        );
      });
      $(".dataContent").remove();
      ajaxPostBuild();
    });

    //Builds Posts based on search
    var ajaxSearchBuild = function(query, query_nonce) {
      $.ajax({
        url: localized_ajax,
        type: "POST",
        data: {
          action: "search_filter",
          query: query,
          query_nonce: query_nonce
        },
        beforeSend: function(xhr) {
          $("#ajax-archive .loading-overlay").show();
          $("#pressReleasesCollapse .postPreview").remove();
          $("#pressReleasesCollapse .noSearchResult").remove();
        },
        success: function(data) {
          $(data).appendTo("#pressReleasesCollapse");
          $(".pressReleaseCollapseBtnContainer").show();
          $("#pressReleasesCollapse").collapse("show");
          $("#ajax-archive .loading-overlay").hide();
        }
      });
      return false;
    };

    //Search Click function
    $("#searchsubmit").click(function(e) {
      e.preventDefault();
      var queryBox = $('#pr_search input[name="s"]');
      var query = $('#pr_search input[name="s"]').val();
      var query_nonce = $('#pr_search input[name="_wpnonce"]').val();
      $("#pressReleasesCollapse");
      if (!$(queryBox).val()) {
        $(".warning").show();
      } else {
        $("#pressReleasesCollapse").collapse("hide");
        $(".warning").hide();
        ajaxSearchBuild(query, query_nonce);
      }
    });

    $("#pressReleasesCollapse").on("hide.bs.collapse", function() {
      $(".pressReleaseCollapseBtnContainer span").html("Show search results");
    });
    $("#pressReleasesCollapse").on("shown.bs.collapse", function() {
      $(".pressReleaseCollapseBtnContainer span").html("Hide search results");
    });

    //Builds Posts based on checkbox filters
    var ajaxPostBuild = function(
      searchIDs,
      pagevalOffset,
      pageVal,
      filter_nonce
    ) {
      $.ajax({
        url: localized_ajax,
        type: "POST",
        data: {
          action: "cat_filter",
          attachmentID: searchIDs,
          offset: pagevalOffset,
          pageVal: pageVal,
          filter_nonce: filter_nonce,
          page_nonce: page_nonce
        },
        beforeSend: function(xhr) {
          $("#ajax-archive .loading-overlay").show();
        },
        success: function(data) {
          $("#pressReleaseSelect").remove();
          successAjaxProc();
          $(data).appendTo(".pressReleasesTabs.filterContent");
          removeDisabled();
          $(".filteredPaginate a.first-page").addClass("disabled");
          $(".filteredPaginate a.prev").addClass("disabled");
          $('.filteredPaginate a[data-page-ref="1"]').addClass("disabled");
          $('.filteredPaginate a[data-page-ref="1"]').after(
            '<span aria-current="page" class="current">' + "1" + "</span>"
          );
          createSelect();
          setActiveTab();
          clonePageination(currentYear);
          widthCheck();
          $("#ajax-archive .loading-overlay").hide();
        }
      });
      return false;
    };

    var ajaxInitialPostBuild = function(page_nonce) {
      $.ajax({
        url: localized_ajax,
        type: "POST",
        data: {
          action: "cat_filter",
          page_nonce: page_nonce
        },
        beforeSend: function(xhr) {
          $("#ajax-archive .loading-overlay").show();
        },
        success: function(data) {
          $("#pressReleaseSelect").remove();
          successAjaxProc();
          $(data).appendTo(".pressReleasesTabs.filterContent");
          removeDisabled();
          $(".filteredPaginate a.first-page").addClass("disabled");
          $(".filteredPaginate a.prev").addClass("disabled");
          $('.filteredPaginate a[data-page-ref="1"]').addClass("disabled");
          $('.filteredPaginate a[data-page-ref="1"]').after(
            '<span aria-current="page" class="current">' + "1" + "</span>"
          );
          createSelect();
          setActiveTab();
          clonePageination(currentYear);
          widthCheck();
          $("#ajax-archive .loading-overlay").hide();
        }
      });
      return false;
    };

    ajaxInitialPostBuild(page_nonce);

    //Paginate number click function
    $(".filterContent").on(
      "click",
      ".tab-content .filteredPaginate a.page-numbers",
      function(e) {
        e.preventDefault();
        $("#ajax-archive .loading-overlay").show();
        var page_nonce = $(
          '.pressReleasesTabsContainer input[name="_wpnonce"]'
        ).val();
        var pagesTotal = $(this)
          .parent()
          .find(".page-numbers").length;
        var pageVal = $(this).data("page-ref");
        var pagevalOffset = (pageVal - 1) * 5;
        var searchIDs = $("#checkBoxesContainer input:checkbox:checked")
          .map(function() {
            return $(this).attr("name");
          })
          .get();

        ajaxPaginate(searchIDs, pagevalOffset, pageVal, pagesTotal, page_nonce);
      }
    );

    //Paginate skip click function
    $(".filterContent").on(
      "click",
      ".tab-content .filteredPaginate a.skip",
      function(e) {
        e.preventDefault();
        $("#ajax-archive .loading-overlay").show();
        var page_nonce = $(
          '.pressReleasesTabsContainer input[name="_wpnonce"]'
        ).val();
        var pagesTotal = $(this)
          .parent()
          .find(".page-numbers").length;
        var skipVal = $(
          ".tab-content .filterResultInfoContainer .results .firstNumber"
        ).html();
        //last number
        var lastVal = $(
          ".tab-content .filterResultInfoContainer .results .results"
        ).html();
        var searchIDs = $("#checkBoxesContainer input:checkbox:checked")
          .map(function() {
            return $(this).attr("name");
          })
          .get();
        if ($(this).data("page-ref") === "previous") {
          var divide = skipVal / 5;
          var round = Math.ceil(divide);
          var pagevalOffset = round * 5 - 10;
          pageVal = round - 1;
        }
        if ($(this).data("page-ref") === "next") {
          var divide = skipVal / 5;
          var round = Math.ceil(divide);
          var pagevalOffset = round * 5;
          pageVal = round + 1;
        }
        if ($(this).data("page-ref") === "first") {
          var pagevalOffset = 0;
          pageVal = 1;
        }
        if ($(this).data("page-ref") === "last") {
          var divide = lastVal / 5;
          var round = Math.ceil(divide) - 1;
          var pagevalOffset = round * 5;
          pageVal = round + 1;
        }
        ajaxPaginate(searchIDs, pagevalOffset, pageVal, pagesTotal, page_nonce);
      }
    );

    //Paginate nuber click Ajax call
    var ajaxPaginate = function(
      searchIDs,
      pagevalOffset,
      pageVal,
      pagesTotal,
      page_nonce
    ) {
      // var filter = $("#filter");
      $.ajax({
        url: localized_ajax,
        type: "POST",
        data: {
          action: "cat_filter",
          attachmentID: searchIDs,
          offset: pagevalOffset,
          pageVal: pageVal,
          totalPages: pagesTotal,
          page_nonce: page_nonce
        },
        success: function(data) {
          $("#pressReleaseSelect").remove();
          successAjaxProc();
          $(data).appendTo(".pressReleasesTabs.filterContent");
          $(".filteredPaginate  .current").each(function() {
            $(this).remove();
          });
          $(".filteredPaginate").each(function() {
            if (pageVal > pagesTotal) {
              $(".filteredPaginate a.next").addClass("disabled");
            }
          });
          if (pageVal === pagesTotal) {
            removeDisabled();
            $(".filteredPaginate a.next").addClass("disabled");
            $(".filteredPaginate a[data-page-ref=" + pageVal + "]").addClass(
              "disabled"
            );
            $(".filteredPaginate a[data-page-ref=" + pageVal + "]").after(
              '<span aria-current="page" class="current">' + pageVal + "</span>"
            );
          } else if (pageVal === 1) {
            $(".filteredPaginate a.prev").addClass("disabled");
            $('.filteredPaginate a[data-page-ref="1"]').addClass("disabled");
            $(".filteredPaginate a[data-page-ref=" + pageVal + "]").after(
              '<span aria-current="page" class="current">' + pageVal + "</span>"
            );
          } else {
            $(".filteredPaginate a[data-page-ref=" + pageVal + "]").addClass(
              "disabled"
            );
            $(".filteredPaginate a[data-page-ref=" + pageVal + "]").after(
              '<span aria-current="page" class="current">' + pageVal + "</span>"
            );
          }

          createSelect();
          setActiveTab();
          clonePageination(currentYear);
          widthCheck();
          resultMessage(currentYear);
          $("#ajax-archive .loading-overlay").hide();
        }
      });
      return false;
    };
  }
});
